/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.messages-filled\":\"Message bubble with smiley face\"}");